const EXPORT_CLIENTS = "/sales/clients/account-balance/clients"
const EXPORT_PROVIDERS = "/sales/clients/account-balance/providers"

export const salesClientsEndpoints = { EXPORT_CLIENTS, EXPORT_PROVIDERS }
